import { useTranslation } from 'react-i18next';
import { LANGUAGES, LanguageCode } from '@/i18n/languages';
import { markManualLanguage } from '@/i18n/manualLanguage';
import { Dropdown, DropdownItem } from '@/components/ui/Dropdown';

/**
 * Topbar + footer language switcher. Replaces the native `<select>`
 * with a polished Radix-based dropdown so the flag + native name
 * render consistently across browsers + OS, plus we get keyboard
 * nav, type-ahead, and dark mode out of the box.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = ((i18n.language || 'en').split('-')[0] as LanguageCode);

  const items: DropdownItem<LanguageCode>[] = LANGUAGES.map((l) => ({
    value: l.code,
    label: l.nativeName,
    hint: l.englishName,
    leading: <span aria-hidden>{l.flag}</span>,
  }));

  return (
    <Dropdown<LanguageCode>
      value={current}
      onChange={(next) => {
        markManualLanguage();
        void i18n.changeLanguage(next);
      }}
      items={items}
      ariaLabel={t('common.language', { defaultValue: 'Language' }) as string}
      size="sm"
      width={170}
    />
  );
}
